import styled from 'styled-components';
import {
  color,
  container,
  fontSize,
  fontWeight,
  radius,
  screen,
  shadow,
  spacing
} from 'theme';
import { getPublicPath } from 'utils/paths';

export const StyledWrapper = styled.div`
  background-image: ${() =>
    `url('${getPublicPath('/images/salaryCompass/compass.svg')}')`};
  background-repeat: no-repeat;
  background-position: left bottom;
`;

export const StyledContainer = styled.div`
  max-width: ${container('xlMax')};
  margin: auto;
  padding: ${spacing('xl3')} ${spacing('md')} ${spacing('xl6')};
  text-align: center;
`;

export const StyledFeatures = styled.div`
  margin-top: ${spacing('xl')};
  margin-bottom: ${spacing('xl')};
  display: grid;
  gap: ${spacing('xl')};
  grid-template-columns: minmax(0, 1fr);

  @media (min-width: ${screen('md')}) {
    grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
  }
`;

export const StyledFeature = styled.div`
  background-color: ${color('white')};
  border-radius: ${radius('lg')};
  box-shadow: ${shadow('md')};
  padding: ${spacing('xl')};
  text-align: left;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: ${spacing('md')};

  img {
    display: block;
    height: 5rem;
  }

  h3 {
    margin: 0;
    font-size: ${fontSize('lg')};
    font-weight: ${fontWeight('extraBold')};

    &::before {
      content: '';
      display: block;
      width: ${spacing('xl')};
      height: ${spacing('xs2')};
      background-color: ${color('emerald_600')};
      margin-bottom: ${spacing('sm')};
    }
  }

  p {
    margin: 0;
    line-height: 1.5;
  }
`;
